export const sanity = {
  projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'oaglaatp',
  dataset: process.env.GATSBY_SANITY_DATASET || 'production',
}
export const indexPage = {
  postsPerCategory: 5,
  categoryWhitelist: {
    '273280b1-e34d-5289-a244-39eb30f8e62d': 'Job Options',
    'cf034cab-32f7-54a3-aa39-64d079c2d384': null,
    '4f066665-cf21-5438-aefe-876a2ed86c4d': 'Companies',
    '0567d84a-5ecb-5520-81e8-0471d6d90f1d': 'Career',
    '1c48e94a-c72c-4661-859a-51f1960395fa': null,
    '892cc2e3-3faf-4b59-9b84-75e7a8bfea05': null,
  },
}
